// lowercase
export enum ControlClassEnum {
  ListInput = 'list_input',
  Input = 'input',
  Switch = 'switch',
  DatePicker = 'date_picker',
  Selector = 'selector'
}
